module.exports = __webpack_public_path__ + "static/media/PM22.2d684582.JPG";